import axios from '../axios'



/* 
 * 平台录入模块
 */


export const personAdd = (data) => {
    return axios({
        url: '/admin/service/sys_person_add',
        method: 'post',
        data
    })
}
//特殊人员新增
export const SpecialAdd = (data) => {
    return axios({
        url: '/admin/service/sys_person_addAudit',
        method: 'post',
        data
    })
}
/* 
 * 平台编辑模块
 */
export const sys_person_edit = (data) => {
    return axios({
        url: '/admin/service/sys_person_edit',
        method: 'post',
        data
    })
}
// 获取地址
export const get_community_msg = (data) => {
    return axios({
        url: '/admin/service/get_community_msg',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/PlatformEntry.js